// extracted by mini-css-extract-plugin
export default {"containerWrapper":"PrivacyPolicy_containerWrapper__P-uIH","container":"PrivacyPolicy_container__YQU9G","title":"PrivacyPolicy_title__24C1-"};